<template>
  <div>
    <div class="chengzhihao">
      <div class="text on">师傅列表</div>
      <div class="inpBox">
        <div class="iconfont icon-search search"></div>
        <div class="inp">
          <input type="text" placeholder="请输入师傅名字搜索" />
        </div>
      </div>
    </div>
    <div class="leftCont">
      <div class="pzBox pzBoxh">
        <div class="pzCnt">
          <div class="name">工作区域:</div>
          <div class="boxs">
            <div
              class="box"
              :class="item.id == areaOn ? 'on' : ''"
              v-for="item in areaList"
              @click="areaClick(item.id)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="pzCnt">
          <div class="name">零工工种:</div>
          <div class="boxs">
            <div
              class="box"
              :class="item.id == gzTypeOn ? 'on' : ''"
              v-for="item in gzTypeList"
              @click="gzTypeClick(item.id)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="sxCont">
        <div
          class="text"
          :class="item.type == sxTypeOn ? 'on' : ''"
          v-for="item in sxTypeList"
          @click="sxTypeClick(item.type)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="list" v-if="typeOn == 1">
        <div class="li" v-for="item in sfList">
          <div class="img" @click="sFjump(item.member_id)">
            <img :src="$imgUrl + item.avatars" alt="" />
          </div>
          <div class="cont">
            <div class="titleBox">
              <div class="name" @click="sFjump(item.member_id)">
                {{ item.realname }}
              </div>
              <div class="star">
                <div
                  class="iconfont icon-collection_fill"
                  v-for="item in item.star"
                ></div>
              </div>
            </div>
            <div class="box">
              <div class="wzList">
                <div class="wzLi disc">
                  <div class="name">擅长服务:</div>
                  <div class="wzBox">
                    <div class="txt" v-for="chi in item.config_cn">
                      {{ chi }}
                    </div>
                  </div>
                </div>
                <div class="wzLi">
                  <div class="name">服务区域:</div>
                  <div class="texts">
                    {{ item.ling_district_cn }}
                  </div>
                </div>
                <div class="wzLi">
                  <div class="name">个人介绍:</div>
                  <div class="texts">
                    {{ item.ling_content }}
                  </div>
                </div>
              </div>
              <div class="fwBox">
                <div class="text">综合服务分</div>
                <div class="name">{{ item.evaluatelength }}</div>
              </div>
              <div class="fwBox">
                <div class="text">累计服务次数</div>
                <div class="name">{{ item.orderlength }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="fenye" v-if="totalCount > 10">
          <a-pagination
            :default-current="sfPage.pageNo"
            v-model="sfPage.pageNo"
            :total="totalCount"
            :page-size="10"
            @change="sfPageOnChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      searChTxt: "",
      typeOn: 1,
      typeList: ["找工作", "找师傅"],
      areaOn: null,
      areaList: [
        {
          id: "",
          pid: 1142,
          code: 331021,
          name: "不限",
          car: "",
          is_sent: 1,
          is_delete: 0,
        },
        {
          id: 3723,
          pid: 1146,
          code: 0,
          name: "玉城",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3724,
          pid: 1146,
          code: 0,
          name: "坎门",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3725,
          pid: 1146,
          code: 0,
          name: "大麦屿",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3726,
          pid: 1146,
          code: 0,
          name: "楚门",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3727,
          pid: 1146,
          code: 0,
          name: "清港",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3728,
          pid: 1146,
          code: 0,
          name: "龙溪",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3729,
          pid: 1146,
          code: 0,
          name: "芦浦",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3730,
          pid: 1146,
          code: 0,
          name: "沙门",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3731,
          pid: 1146,
          code: 0,
          name: "干江",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3732,
          pid: 1146,
          code: 0,
          name: "鸡山",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3733,
          pid: 1146,
          code: 0,
          name: "海山",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
      ],
      gzTypeOn: null,
      gzTypeList: [],
      judge: true,
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      list: [],
      totalCount: 0,
      sxTypeOn: "",
      sxTypeList: [
        {
          name: "综合",
          type: "",
        },
        {
          name: "热门",
          type: "a.click desc",
        },
        {
          name: "发布时间",
          type: "a.modify_time desc",
        },
      ],
      sfJudge: true,
      sfPage: {
        pageNo: 1,
        pageSize: 10,
      },
      sfList: [],
      sfTotalCount: 0,
      zongPage: {},
    };
  },
  created() {
    this.typeGet();
    this.sfListGet();
  },
  methods: {
    sfListGet() {
      if (!this.sfJudge) {
        return;
      }
      this.sfJudge = false;
      this.$get("/nozzle/web/member_odd_gets", {
        ...this.sfPage,
        ...this.zongPage,
      }).then((res) => {
        console.log(res);
        this.sfJudge = true;
        if (this.sfTotalCount == 0) {
          this.sfTotalCount = res.totalCount;
        }
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
            e.config_cn = e.config_cn.split(",");
            e.star = Math.floor(e.evaluatelength / 20);
          }
          this.sfList = res.data;
        } else {
          this.sfList = [];
        }
      });
    },
    sxTypeClick(id) {
      this.sxTypeOn = id;
      this.zongPage.odb = id;
      this.sfPage.pageNo = 1;
      this.sfTotalCount = 0;
      this.sfListGet();
    },
    sfPageOnChange() {
      this.sfPage.pageNo = i;
      this.sfListGet();
    },
    typeGet() {
      this.$get("/common/configuration_gets", {
        type: "linggong",
      }).then((res) => {
        console.log(res);
        this.gzTypeList = res.data;
        this.gzTypeList.unshift({
          name: "不限",
          id: "",
        });
        if (this.id) {
          for (let i = 0; i < this.gzTypeList.length; i++) {
            const e = this.gzTypeList[i];
            if (e.id == this.id) {
              this.gzTypeOn = e.id;
            }
          }
        }
      });
    },
    gzTypeClick(id) {
      this.gzTypeOn = id;
      this.zongPage.config_id = id;
      this.sfPage.pageNo = 1;
      this.sfTotalCount = 0;
      this.sfListGet();
    },
    areaClick(id) {
      this.areaOn = id;
      this.zongPage.district = id;
      this.sfPage.pageNo = 1;
      this.sfTotalCount = 0;
      this.sfListGet();
    },
    areaGet() {
      this.$get("/common/area_gets", {
        pageNo: -1,
      }).then((res) => {
        console.log(res);
        window.localStorage.setItem("areasList", JSON.stringify(res.data));
        this.areasList = res.data;
      });
    },
    sFjump(id) {
      // this.$router.push({
      //   path: "/ligSfCont",
      //   query: {
      //     id,
      //   },
      // });
      window.open("#/ligSfCont?id=" + id);
    },
    typeClick(i) {
      this.typeOn = i;
      this.sfPage.pageNo = 1;
      this.sfTotalCount = 0;
      this.sfListGet();
    },
    searchClick() {
      this.sfPage.name = this.searChTxt;
      this.sfPage.pageNo = 1;
      this.sfTotalCount = 0;
      this.sfListGet();
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.chengzhihao {
  padding-top: 10px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  .text {
    margin-right: 20px;
    font-size: 18px;
    color: #666;
    cursor: pointer;
  }
  .on {
    font-weight: 600;
    color: #000;
  }
  .inpBox {
    height: 35px;
    border-radius: 5px;
    width: 300px;
    display: flex;
    border: 1px solid #ebebeb;
    background-color: #fff;
    .search {
      height: 35px;
      width: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      color: #9c9c9c;
    }
    .inp {
      width: calc(100% - 35px);
      height: 100%;
      input {
        height: 100%;
        width: 100%;
      }
    }
  }
}
.leftCont {
  overflow: hidden;
  width: 100%;
  margin: auto;
  margin-top: 10px;
  background-color: #fff;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 10px;
  .headBox {
    background-color: #fff;
    border-radius: 10px;
    .typeList {
      display: flex;
      height: 60px;
      font-size: 16px;
      margin-bottom: 10px;
      border-bottom: 2px solid #ebebeb;
      .type {
        box-sizing: border-box;
        height: 60px;
        width: 130px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .on {
        font-weight: 600;
        border-bottom: 2px solid #1677ff;
        color: #1677ff;
        position: relative;
        z-index: 9;
      }
    }
  }
  .pzBox {
    border-bottom: 1px solid #ebebeb;
    height: 61px;
    overflow: hidden;
    position: relative;
    .modoBox {
      position: absolute;
      top: 16px;
      right: 0;
      display: flex;
      background-color: whitesmoke;
      padding: 5px 5px 5px 10px;
      border-radius: 5px;
      cursor: pointer;
      .name {
        font-size: 12px;
      }
      .iconfont {
        font-size: 12px;
      }
      .shang {
        animation: shang 0.5s both;
      }
      @keyframes shang {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(-180deg);
        }
      }
      .xia {
        animation: xia 0.5s both;
      }
      @keyframes xia {
        0% {
          transform: rotate(-180deg);
        }
        100% {
          transform: rotate(0deg);
        }
      }
    }
    .pzCnt {
      display: flex;
      .name {
        font-weight: 600;
        width: 120px;
      }
      .boxs {
        width: calc(100% - 120px);
        overflow: hidden;
        .box {
          float: left;
          margin-right: 25px;
          margin-bottom: 15px;
          color: #666;
          cursor: pointer;
        }
        .on {
          color: #1677ff;
        }
      }
    }
  }
  .pzBoxh {
    height: auto;
  }
  .sxCont {
    padding-top: 20px;
    display: flex;
    align-items: center;
    font-size: 16px;
    position: relative;
    border-bottom: 1px solid #ebebeb;
    padding-bottom: 20px;
    .text {
      margin-right: 25px;
      cursor: pointer;
    }
    .text:hover {
      color: #f66;
    }
    .jgBox {
      display: flex;
      align-items: center;
      cursor: pointer;
      height: 30px;
      margin-right: 25px;
    }
    .on {
      color: #f66;
    }
    .kBox {
      position: absolute;
      top: 50px;
      left: 90px;
      box-shadow: 0 0 4px 2px #ebebeb;
      border-radius: 5px;
      font-size: 14px;
      background-color: #fff;
      z-index: 99;
      .name {
        padding: 10px;
        border-bottom: 1px solid #ebebeb;
        cursor: pointer;
      }
      .name:hover {
        color: #f66;
      }
      .name:last-child {
        border-bottom: none;
      }
    }
    .inpBox {
      display: flex;
      align-items: center;
      .inp {
        width: 80px;
        border-radius: 5px;
        border: 1px solid #cfcfcf;
        height: 35px;
        overflow: hidden;
        box-sizing: border-box;
        input {
          width: 100%;
          height: 100%;
          padding-left: 8px;
          box-sizing: border-box;
          font-size: 14px;
        }
      }
      .hen {
        width: 5px;
        height: 1px;
        background-color: #9c9c9c;
        margin: 0 5px;
      }
      .serveBtn {
        font-size: 14px;
        margin-left: 10px;
        width: 60px;
        border-radius: 5px;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgb(30, 135, 233);
        color: #fff;
        cursor: pointer;
      }
    }
  }
  .lgBox {
    margin-top: 15px;
    .cont {
      cursor: pointer;
      margin-right: 15px;
      border-radius: 5px;
      background-color: #fff;
      margin-bottom: 15px;
      border-bottom: 1px solid #ebebeb;
      padding-bottom: 15px;
      .titBox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .name {
          font-weight: 600;
          font-size: 16px;
        }
        .address {
          color: #9c9c9c;
        }
      }
      .moneyBox {
        display: flex;
        align-items: center;
        margin-top: 8px;
        font-size: 16px;
        color: #ec3d07;
        font-weight: 600;
        .name {
          margin-right: 20px;
        }
      }
      .textBox {
        display: flex;
        margin-top: 5px;
        .text {
          width: 50%;
        }
      }
    }
  }
  .list {
    .li {
      padding-top: 15px;
      display: flex;
      border-bottom: 1px solid #ebebeb;
      padding-bottom: 15px;
      .img {
        width: 80px;
        height: 80px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
      }
      .cont {
        width: calc(100% - 80px);
        padding-left: 30px;
        box-sizing: border-box;
        .titleBox {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          .name {
            font-weight: 600;
            font-size: 20px;
            margin-right: 10px;
            cursor: pointer;
          }
          .star {
            display: flex;
            align-items: center;
            .iconfont {
              color: #ee0707;
              font-size: 20px;
              margin-right: 2px;
            }
          }
        }
        .box {
          display: flex;
          .wzList {
            width: calc(100% - 280px);
            .wzLi {
              margin-bottom: 5px;
              display: flex;
              .name {
                width: 70px;
                color: #666;
                line-height: 150%;
              }
              .wzBox {
                display: flex;
                align-items: center;
                width: calc(100% - 70px);
                .txt {
                  color: #1677ff;
                  border: 1px solid #1677ff;
                  font-size: 12px;
                  border-radius: 5px;
                  padding: 3px 8px;
                  margin-right: 10px;
                }
              }
              .texts {
                width: calc(100% - 70px);
                line-height: 150%;
                color: #333;
              }
            }
            .disc {
              align-items: center;
            }
          }
          .fwBox {
            width: 120px;
            text-align: center;
            .text {
              font-size: 12px;
            }
            .name {
              font-size: 24px;
              font-weight: 600;
            }
          }
        }
      }
    }
    .li:last-child {
      border-bottom: none;
    }
  }
}
</style>
